// src/components/Header.js

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import t from '../i18n';

// Определяем мобильный viewport
function useIsMobile(breakpoint = 640) {
    const [isMobile, setIsMobile] = useState(window.innerWidth < breakpoint);
    useEffect(() => {
        const handler = () => setIsMobile(window.innerWidth < breakpoint);
        window.addEventListener('resize', handler);
        return () => window.removeEventListener('resize', handler);
    }, [breakpoint]);
    return isMobile;
}

function IconHome() {
    return (
        <svg width="18" height="18" fill="none" viewBox="0 0 24 24"
             stroke="#9ca3af" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round"
                  d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"/>
        </svg>
    );
}

function IconSearch({ size = 16, color = '#6b7280' }) {
    return (
        <svg width={size} height={size} fill="none" viewBox="0 0 24 24"
             stroke={color} strokeWidth={2} style={{ flexShrink: 0 }}>
            <circle cx="11" cy="11" r="8"/>
            <path strokeLinecap="round" d="M21 21l-4.35-4.35"/>
        </svg>
    );
}

function IconUser() {
    return (
        <svg width="15" height="15" fill="none" viewBox="0 0 24 24"
             stroke="#9ca3af" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round"
                  d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/>
        </svg>
    );
}

export default function Header() {
    const [query, setQuery]       = useState('');
    const [showModal, setShowModal] = useState(false);
    const navigate  = useNavigate();
    const isMobile  = useIsMobile();

    const handleSearch = () => {
        const q = query.trim();
        if (q) { navigate('/' + q); setQuery(''); }
    };

    return (
        <>
            <header style={s.header}>
                <div style={s.inner}>

                    {/* Лого / Домой */}
                    <button onClick={() => navigate('/')} style={s.logoBtn} title="ordersearch.info">
                        {isMobile
                            ? <IconHome />
                            : <span style={s.logoText}>ordersearch.info</span>
                        }
                    </button>

                    {/* Компактный поиск */}
                    <div style={s.searchWrap}>
                        <IconSearch size={16} />
                        <input
                            style={s.input}
                            placeholder={t.headerPlaceholder}
                            value={query}
                            onChange={e => setQuery(e.target.value)}
                            onKeyDown={e => e.key === 'Enter' && handleSearch()}
                            autoComplete="off"
                            spellCheck="false"
                        />
                        <button onClick={handleSearch} style={s.searchBtn}>
                            <IconSearch size={13} color="white" />
                            {!isMobile && (
                                <span style={s.searchBtnText}>{t.searchButton}</span>
                            )}
                        </button>
                    </div>

                    {/* Sign in — заглушка */}
                    <button onClick={() => setShowModal(true)} style={s.signInBtn}>
                        {isMobile
                            ? <IconUser />
                            : <span>Sign in</span>
                        }
                    </button>

                </div>
            </header>

            {/* Coming soon модал */}
            {showModal && (
                <div style={s.overlay} onClick={() => setShowModal(false)}>
                    <div style={s.modal} onClick={e => e.stopPropagation()}>
                        <p style={s.modalTitle}>Coming soon</p>
                        <p style={s.modalText}>{t.authComingSoon}</p>
                        <button onClick={() => setShowModal(false)} style={s.modalOk}>
                            OK
                        </button>
                    </div>
                </div>
            )}
        </>
    );
}

const s = {
    header: {
        position:        'sticky',
        top:             0,
        zIndex:          20,
        backgroundColor: '#121212',
        borderBottom:    '1px solid #1e1e1e',
        flexShrink:      0,
    },
    inner: {
        maxWidth:       '1200px',
        margin:         '0 auto',
        padding:        '0 12px',
        height:         56,
        display:        'flex',
        alignItems:     'center',
        gap:            10,
    },
    logoBtn: {
        flexShrink:      0,
        background:      'transparent',
        border:          '1px solid #2a2a2a',
        borderRadius:    8,
        padding:         '6px 10px',
        cursor:          'pointer',
        display:         'flex',
        alignItems:      'center',
        justifyContent:  'center',
    },
    logoText: {
        fontFamily: 'monospace',
        fontSize:   12,
        color:      '#9ca3af',
        whiteSpace: 'nowrap',
    },
    searchWrap: {
        flex:            1,
        display:         'flex',
        alignItems:      'center',
        gap:             8,
        backgroundColor: '#1e1e1e',
        border:          '1px solid #2a2a2a',
        borderRadius:    8,
        padding:         '0 6px 0 10px',
        height:          36,
        minWidth:        0,
    },
    input: {
        flex:       1,
        background: 'transparent',
        border:     'none',
        outline:    'none',
        color:      '#e0e0e0',
        fontSize:   13,
        minWidth:   0,
    },
    searchBtn: {
        flexShrink:      0,
        backgroundColor: '#6200ea',
        border:          'none',
        borderRadius:    6,
        padding:         '5px 8px',
        cursor:          'pointer',
        display:         'flex',
        alignItems:      'center',
        gap:             4,
    },
    searchBtnText: {
        color:      'white',
        fontSize:   12,
        fontWeight: 600,
    },
    signInBtn: {
        flexShrink:  0,
        background:  'transparent',
        border:      '1px solid #2a2a2a',
        borderRadius: 8,
        padding:     '6px 12px',
        cursor:      'pointer',
        color:       '#9ca3af',
        fontSize:    12,
        display:     'flex',
        alignItems:  'center',
        whiteSpace:  'nowrap',
    },
    overlay: {
        position:        'fixed',
        inset:           0,
        backgroundColor: 'rgba(0,0,0,0.65)',
        display:         'flex',
        alignItems:      'center',
        justifyContent:  'center',
        zIndex:          50,
        padding:         16,
    },
    modal: {
        backgroundColor: '#1e1e1e',
        border:          '1px solid #2a2a2a',
        borderRadius:    16,
        padding:         28,
        maxWidth:        280,
        width:           '100%',
        textAlign:       'center',
    },
    modalTitle: {
        color:        '#fff',
        fontSize:     18,
        fontWeight:   600,
        marginBottom: 8,
        marginTop:    0,
    },
    modalText: {
        color:        '#888',
        fontSize:     14,
        marginBottom: 24,
        marginTop:    0,
    },
    modalOk: {
        backgroundColor: '#6200ea',
        color:           '#fff',
        border:          'none',
        borderRadius:    8,
        padding:         '10px 40px',
        fontSize:        14,
        fontWeight:      600,
        cursor:          'pointer',
    },
};
